// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"549":"ef802eebaea4ddaa","735":"ef3d97e7284dca53"}[chunkId] + ".js";
};